import React from 'react';
import { Banner, Spacer, Text } from '@zillow/constellation';
import styled from 'styled-components';
var StyledWrapper = styled.div.withConfig({
  displayName: "AbadContent__StyledWrapper",
  componentId: "sc-1y1tzvg-0"
})(["max-height:350px;overflow-y:", ";"], function (props) {
  return props.isModal ? 'visible' : 'auto';
});

var AbadContent = function AbadContent(_ref) {
  var abadHtml = _ref.abadHtml,
      isModal = _ref.isModal;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    isModal: isModal,
    "data-testid": "contact-agent-abad"
  }, /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "sm"
  }, /*#__PURE__*/React.createElement(Banner, {
    appearance: "info",
    body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "What's This?"), " Zillow has affiliated businesses that help make home buying and selling easier. You have not agreed to work with any of these affiliates, this is only meant to inform you in case you want to in the future.")
  })), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: abadHtml
    }
  })));
};

export default AbadContent;
//# sourceMappingURL=AbadContent.js.map